const managebanner = {
    path: 'agentbanner/managebanner',
    component: resolve => require(['@/pages/admin/ad/agentbanner/managebanner/index.vue'], resolve),
    meta: {
        requireAuth: true
    }
}

export default managebanner